import React, { useContext } from 'react';

import { Button } from '@iwoca/orion';
import { clsx } from 'clsx';

import { ActivationContext } from '../../../../activation/Activation';
import { LinkWithQuery } from '../../../../components/LinkWithQuery/LinkWithQuery';
import { LockedButton } from '../../../../components/LockedButton/LockedButton';

export function ConnectButton({
  children,
  isConnected = false,
  link,
  isExternal,
  onClick,
  className,
}: {
  children: React.ReactNode;
  isConnected?: boolean;
  link?: string;
  isExternal?: boolean;
  onClick?: () => void;
  className?: string;
}) {
  const { isOnboarded, isLoading } = useContext(ActivationContext);

  if (isLoading) return null;

  if (!isOnboarded) return <LockedButton />;

  if (onClick)
    return (
      <Button
        variant={isConnected ? 'secondary-alt' : 'primary'}
        className={clsx('!px-xl !py-m max-800:!w-full', className)}
        onClick={onClick}
      >
        {children}
      </Button>
    );

  if (isExternal)
    return (
      <a href={link} rel="noopener noreferrer">
        <Button
          variant={isConnected ? 'secondary-alt' : 'primary'}
          className={clsx('!px-xl !py-m max-800:!w-full', className)}
        >
          {children}
        </Button>
      </a>
    );

  return (
    <>
      <LinkWithQuery to={link!}>
        <Button
          variant={isConnected ? 'secondary-alt' : 'primary'}
          className={clsx('!px-xl !py-m max-800:!w-full', className)}
        >
          {children}
        </Button>
      </LinkWithQuery>
    </>
  );
}
